import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type UserGroupSpecsFragment } from '../../../api/fragments/UserGroupSpecs';
import DrawerWithAutoWidth from '../../../components/DrawerWithAutoWidth';
import UserGroupUpdateForm from './UserGroupUpdateForm';

export type UserGroupUpdateDrawerProps = {
    userGroup: UserGroupSpecsFragment;
    onClose: () => void;
    visible: boolean;
};

const UserGroupUpdateDrawer = ({ userGroup, onClose, visible }: UserGroupUpdateDrawerProps) => {
    const { t } = useTranslation(['userGroupDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('userGroupDetails:updateDrawer.cancelButton')}</Button>
                    <Button form="updateUserGroup" htmlType="submit" type="primary">
                        {t('userGroupDetails:updateDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('userGroupDetails:updateDrawer.title')}
            visible={visible}
            destroyOnClose
        >
            <UserGroupUpdateForm onComplete={onClose} userGroup={userGroup} />
        </DrawerWithAutoWidth>
    );
};

export default UserGroupUpdateDrawer;

export const useUpdateUserGroupDrawer = (userGroup: UserGroupUpdateDrawerProps['userGroup']) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <UserGroupUpdateDrawer onClose={actions.close} userGroup={userGroup} visible={visible} />,
    };
};
